const $ = require('jquery');
const util = require('../../utils/util');
const validator = require('../../utils/validator');
const uniform = require('../../components/uniform');
const packstation = require('../../components/packstation');
const inputfields = require('../../utils/inputfields');
const showpassword = require('../../utils/showpassword');
const addressSearch = require('./addressSearch');

/**
 * Initializes the events for the checkboxes when editing an address
 *
 */
const initCheckboxEvents = function () {
    $('#set-as-primary').on('focusin', function () {
        $(this).closest('.checker').addClass('focus');
    });
    $('#set-as-primary').on('focusout', function () {
        $(this).closest('.checker').removeClass('focus');
    });

    $('#set-as-primary').on('click', function () {
        $(this).parent().toggleClass('checked');
    });
};

/**
 * Initializes the events for profile update/ email update/ password update/ account deletion update
 *
 */
const initializeEvents = function () {
    /**
     * Updates the customer's profile data.
     *
     * @param {Event} e event
     */
    const bindProfileUpdate = function (e) {
        e.preventDefault();

        if ($(this).valid()) {
            $.ajax({
                type: 'POST',
                url: util.appendParamToURL($(this).attr('action'), 'format', 'ajax'),
                data: $(this).serialize()
            }).done(function (data) {
                $('.section-data').parent().html(data);
                initializeEvents();
                uniform();
                inputfields.updateSelectBoxes();
            });
        }
    };

    /**
     * Updates the customer's email address
     *
     * @param {Event} e event
     */
    const bindEmailUpdate = function (e) {
        e.preventDefault();

        if ($(this).valid()) {
            $.ajax({
                type: 'POST',
                url: util.appendParamToURL($(this).attr('action'), 'format', 'ajax'),
                data: $(this).serialize()
            }).done(function (data) {
                $('.section-mail').parent().html(data);
                showpassword.init();
                initializeEvents();
            });
        }
    };

    /**
     * Updates the customer's password
     *
     * @param {Event} e event
     */
    const bindPasswordUpdate = function (e) {
        e.preventDefault();

        if ($(this).valid()) {
            $.ajax({
                type: 'POST',
                url: util.appendParamToURL($(this).attr('action'), 'format', 'ajax'),
                data: $(this).serialize()
            }).done(function (data) {
                $('.section-password').parent().html(data);
                showpassword.init();
                initializeEvents();
            });
        }
    };

    /**
     * Called when deleting an account
     *
     * @param {Event} e event
     */
    const bindDeleteAccUpdate = function (e) {
        e.preventDefault();

        if ($(this).valid()) {
            $.ajax({
                type: 'POST',
                url: util.appendParamToURL($(this).attr('action'), 'format', 'ajax'),
                data: $(this).serialize()
            }).done(function (data) {
                $('.section-delete').parent().html(data);

                if (data.indexOf('success-form') > -1) {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'accountDeletionSuccessful'
                        });
                    }
                }

                showpassword.init();
                initializeEvents();
            });
        }
    };

    $('#RegistrationForm').on('submit', bindProfileUpdate);
    $('#ChangeEmailForm').on('submit', bindEmailUpdate);
    $('#ChangePasswordForm').on('submit', bindPasswordUpdate);
    $('#DeleteAccountForm').on('submit', bindDeleteAccUpdate);

    validator.init();

    $('.editprofile-password-form .disablecopypaste input').bind('copy paste', function (e) {
        e.preventDefault();
    });
};

/**
 * Initializes the events for the address book
 *
 */
const initAddressBookEvents = function () {
    const isEnableKakaoAddressSearch = $('.address-container').data('enable-kakao-address-search');
    if (isEnableKakaoAddressSearch) {
        addressSearch.init();
    }

    /**
     * Handles the response when changes are made (after editing an address) or creating a new address
     *
     * @param {string} data response from server.
     * @param {boolean} setAsPrimary setAsPrimary
     * @param {boolean} setAsPrimaryUrl setAsPrimaryUrl
     */
    const handleAddressResponse = function (data, setAsPrimary, setAsPrimaryUrl) {
        if (!data) {
            return;
        }

        if (data.indexOf('addressValidationErrorEdit') >= 0) {
            $('#address-form-container').html(data);
            util.scrollBrowser($('#address-form-container').offset().top, true);

            if (setAsPrimary) {
                $('#set-as-primary').prop('checked', true);
                $('#set-as-primary-checker').addClass('checked');
            }
        } else if (data.indexOf('addressValidationErrorAdd') >= 0) {
            $('#addresses').parent().html(data);
            $('#address-form-container').show();
            util.scrollBrowser($('#address-form-container').offset().top, true);

            if (setAsPrimary) {
                $('#set-as-primary').prop('checked', true);
                $('#set-as-primary-checker').addClass('checked');
            }
        } else if (setAsPrimary) {
            $.ajax({
                type: 'POST',
                url: setAsPrimaryUrl
            }).done(function (resp) {
                handleAddressResponse(resp, false);
                initAddressBookEvents();
            });
        } else {
            $('#addresses').parent().html(data);
            $('.add-new-address').show();
            util.scrollBrowser($('#address-list-section').offset().top, true);
        }

        const packstationInput = $('.is-packstation-row input');
        const isPackstation = packstationInput && packstationInput.prop('checked');

        if (isPackstation) {
            packstation.updateShippingForPackstation();
        }
    };

    /**
     * Hides the 'address-form-container' upon aborting when editing an address
     *
     * @param {Event} ev event
     */
    const bindEditAddressCancel = function (ev) {
        ev.preventDefault();
        $('#address-form-container').hide();
        $('.add-new-address').show();

        const target = $(ev.target);
        const name = target.attr('name');

        util.scrollBrowser($('#address-list-section').offset().top, true);

        $('.jsAddressformAction').attr('name', name);
    };

    /**
     * Called when saving changes (after editing an address) or after creating a new address
     *
     * @param {Event} ev event
     */
    const bindAddressSubmit = function (ev) {
        ev.preventDefault();

        if ($(this).valid()) {
            const setAsPrimaryCheckbox = $('#set-as-primary');
            const setAsPrimary = setAsPrimaryCheckbox.length && setAsPrimaryCheckbox.prop('checked');

            let setAsPrimaryUrl = '';

            if (setAsPrimary) {
                setAsPrimaryUrl = util.appendParamToURL(
                    $('#set-as-primary').data().url,
                    'AddressID',
                    $('#dwfrm_profile_address_addressid').val()
                );
            }

            $.ajax({
                type: 'POST',
                url: $(this).attr('action'),
                data: $(this).serialize()
            }).done(function (data) {
                handleAddressResponse(data, setAsPrimary, setAsPrimaryUrl);
                initAddressBookEvents();
            });
        }
    };
    /**
     * Initializes the events for editing an address
     *
     * @param {Event} e event
     */
    const initAddressEditEvents = function (e) {
        validator.init();
        // uniform re-init
        uniform();

        // update form for packstation if required
        packstation.updateShippingForPackstation(e);

        // auto complete for japanese zip code and prefection
        $('[data-jpzipcomplete-htmlname]').each(function () {
            require('../../components/jpzipcomplete')($(this));
        });

        // reinit all select boxes after the form is updated
        inputfields.updateSelectBoxes();
        inputfields.init();

        // handle city-area shipping address dropdown for MEA region
        $('#dropdown-city-profile').on('change', function () {
            const selectedCityId = $(this).find(':selected').data('city');
            const params = {
                format: 'ajax',
                city: selectedCityId
            };

            $.ajax({
                type: 'GET',
                url: util.appendParamsToUrl(Urls.getAreasByCity, params)
            }).done(function (data) {
                $('#dropdown-area-profile').empty().append(data);
                // Resets and clears out the previously selected Area
                $('#dropdown-area-profile option:eq(0)').prop('selected', true).trigger('change');
            });

            $('#dwfrm_profile_address_city').val(this.value);
            $('#dwfrm_profile_address_cityID').val(this.value);
        });

        $('#dropdown-area-profile').on('change', function () {
            $('#dwfrm_profile_address_cityArea').val(this.value);
        });
    };

    /**
     * Loads 'address-form-container' for editing an address
     *
     * @param {Event} e event
     */
    const bindEditAddress = function (e) {
        e.preventDefault();

        $.ajax({
            url: util.appendParamToURL($(this).attr('href'), 'format', 'ajax')
        }).done(function (data) {
            $('#address-form-container').html(data);

            $('.add-new-address').hide();
            $('#address-form-container').show();
            util.scrollBrowser($('#address-form-container').offset().top, true);

            initAddressEditEvents();
            initAddressBookEvents();
        });
    };

    /**
     * Called when the 'Enter New Address' button is pressed and shows the 'address-form-container'.
     *
     * @param {Event} e event
     */
    const bindAddNewAddress = function (e) {
        e.preventDefault();
        $.ajax({
            url: util.appendParamToURL($(this).attr('href'), 'format', 'ajax')
        }).done(function (data) {
            $('#addresses').parent().html(data);
            $('.add-new-address').hide();
            $('#address-form-container').show();
            util.scrollBrowser($('#address-form-container').offset().top, true);

            initAddressEditEvents();
            initAddressBookEvents();
        });
    };

    /**
     * Deletes a selected address.
     *
     * @param {Event} e event
     */
    const bindDeleteAddress = function (e) {
        e.preventDefault();
        $.ajax({
            url: util.appendParamToURL($(this).attr('href'), 'format', 'ajax')
        }).done(function (data) {
            if (data) {
                $('#addresses').parent().html(data);
                util.scrollBrowser($('#address-list-section').offset().top, true);

                initAddressBookEvents();
            }
        });
    };

    $('.add-new-address').on('click', 'a', bindAddNewAddress);
    $('#addressform').on('submit', bindAddressSubmit);
    $('.jsAddressformCancel').on('click', bindEditAddressCancel);

    initCheckboxEvents();
    const $addresses = $('#addresses');

    if ($addresses.length === 0) {
        return;
    }

    $addresses
        .on('click', '.is-packstation-row input', function (e) {
            packstation.updateShippingForPackstation(e);
        })
        .on('click', '.address-edit', bindEditAddress)
        .on('click', '.address-delete', bindDeleteAddress);
};

/**
 * Init function.
 */
exports.init = function () {
    initializeEvents();
    initAddressBookEvents();
};
